import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/clips/')({
  beforeLoad: () => {
    throw redirect({ to: '/clips/my-custom-clips' });
  },
});
